module.exports = __webpack_public_path__ + "files/6f18d101b6532141d79c719a4b85788e.png";